import React from "react";
import { Navigate } from "react-router-dom";
import { canAccess } from "../../permissions";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ componentKey, element }) {
  const { user } = useAuth();
  console.log(`Checking access for: ${componentKey}`);
  const allowed = canAccess(componentKey);
  console.log(`Access allowed: ${allowed}`);
  const token = localStorage.getItem("token");
  if (!token) {
    // If not authenticated, redirect to login
    return <Navigate to="/login" replace />;
  }
  return element;
}
